import React from 'react'

export const IOS = props => (
	<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			d='M16.3529 12.3981C16.3467 11.2512 16.8654 10.3856 17.9154 9.7481C17.3279 8.90747 16.4404 8.44497 15.2686 8.35435C14.1592 8.26685 12.9467 9.00122 12.5029 9.00122C12.0342 9.00122 10.9592 8.3856 10.1154 8.3856C8.37168 8.41372 6.51855 9.77622 6.51855 12.5481C6.51855 13.3668 6.66855 14.2127 6.96855 15.0856C7.36855 16.2325 8.8123 19.045 10.3186 18.9981C11.1061 18.9793 11.6623 18.4387 12.6873 18.4387C13.6811 18.4387 14.1967 18.9981 15.0748 18.9981C16.5936 18.9762 17.8998 16.42 18.2811 15.27C16.2436 14.3106 16.3529 12.4575 16.3529 12.3981ZM14.5842 7.26685C15.4373 6.25435 15.3592 5.33247 15.3342 5.00122C14.5811 5.04497 13.7092 5.51372 13.2123 6.09185C12.6654 6.7106 12.3436 7.47622 12.4123 8.33872C13.2279 8.40122 13.9717 7.98247 14.5842 7.26685Z'
			fill='#212121'
		/>
	</svg>
)
